export const style = {
    report: {
        fontFamily: 'Inter, sans-serif',
        lineHeight: '58.09px',
        letterSpacing: '10px',
    },
    serviceReport: {
        fontFamily: 'Inter, sans-serif',
        lineHeight: '29.05px',
    },
    all: {
        borderTopWidth: '1px',
        borderLeftWidth: '1px',
        borderBottomWidth: '1px',
        borderRightWidth: '0px',
        borderRadius: '10px 0px 0px 10px',
    },
    allText: {
        fontFamily: 'Inter, sans-serif',
        lineHeight: '21.78px',
        textAlign: 'center',
    },
    caret: {
        borderTopWidth: '1px',
        borderLeftWidth: '0px',
        borderBottomWidth: '1px',
        borderRightWidth: '1px',
        borderRadius: '0px 10px 10px 0px',
    },
    caretIcon: {
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
    all2: {
        borderTopWidth: '1px',
        borderLeftWidth: '1px',
        borderBottomWidth: '1px',
        borderRightWidth: '1px',
        borderRadius: '10px 10px 10px 10px',
    },
    submit: {
        fontFamily: 'Inter, sans-serif',
        lineHeight: '29.05px',
        textAlign: 'center',
    },
};